import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { DEFAULT_SITE_NAVIGATION, fetchSiteNavigation, publicNavigationItems } from '../../siteNavigation';

export default function AFooter() {
  const [navigation, setNavigation] = useState(DEFAULT_SITE_NAVIGATION);

  useEffect(() => {
    let cancelled = false;
    fetchSiteNavigation()
      .then((data) => {
        if (!cancelled) setNavigation(data);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  const conferenceLink = publicNavigationItems(navigation.current_conferences)[0] || DEFAULT_SITE_NAVIGATION.current_conferences[0];
  const workshopLink = publicNavigationItems(navigation.workshops)[0] || DEFAULT_SITE_NAVIGATION.workshops[0];
  const publicationLink = publicNavigationItems(navigation.publications)[0] || DEFAULT_SITE_NAVIGATION.publications[0];

  return (
    <footer>
      <div className="shell footer-grid">
        <div className="footer-brand">
          <img src={require('../../imgs/agist-template/02-training-conference.webp')} alt="AGIST" />
          <p>Advancing intelligent science and technology for the betterment of humanity.</p>
        </div>
        <div>
          <h3>Explore</h3>
          <Link to="/home">Home</Link>
          <Link to="/about">About AGIST</Link>
          <a href={conferenceLink.url}>Conferences</a>
          <a href={workshopLink.url}>Workshops and Training</a>
          <a href={publicationLink.url}>Publications</a>
        </div>
        <div>
          <h3>Connect</h3>
          <Link to="/membership">Membership</Link>
          <Link to="/news">News</Link>
          <Link to="/contact">Contacts</Link>
          <a href="mailto:info@agist.org">info@agist.org</a>
          <a href="https://twitter.com/DaoAgist">X / Twitter</a>
        </div>
      </div>
      <div className="shell footer-bottom">
        <p>&copy; {new Date().getFullYear()} Association of Global Intelligent Science and Technology.</p>
        <p>AGIST &middot; Global scholarship in intelligent science</p>
      </div>
    </footer>
  )
}
